import axios from 'axios'
import Cookie from 'js-cookie'
import RoutePath from '../RoutePath';

let refreshTokenPromise;

const getRefreshToken = async () => {
    console.log("[i] response unauth, token expire, need refresh");


    // if error happened here it would be thrown up to the caller
    try {
        if (!Cookie.get("refresh_token")) {
            console.log("refresh token not exist")
            throw "refresh token not exist"
        }
        const refreshResp = await axios.get(process.env.REACT_APP_BASE_API_URL + "auth/refresh", {
            headers: {
                Authorization: "Bearer " + Cookie.get("refresh_token")
            }
        });
        const { access_token, refresh_token } = refreshResp.data.data;
        console.log("set access token from refresh")
        Cookie.set("token", access_token);

        if (refresh_token) {
            Cookie.set("refresh_token", refresh_token);
        }
    } catch (error) {
        Cookie.remove('token');
        Cookie.remove('refresh_token');
        Cookie.remove('authorizations');
        Cookie.remove('user');
        window.location.href = RoutePath.LOGIN;
    }
}

// Add a request interceptor
// axios.interceptors.request.use((config)=> {
//     // Do something before request is sent
//     return config;
// }, (error)=> {
//     // Do something with request error
//     return Promise.reject(error);
// });

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log("response okay")
    return response;
}, (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error 
    return new Promise((resolve, reject) => {

        if (error.response.status === 401 && error.response.headers["token-expire"]) {
            console.log("interceptor error token expired")
            if (!refreshTokenPromise) {
                refreshTokenPromise = getRefreshToken().then(() => {
                    refreshTokenPromise = null;
                    // window.location.reload();
                }).catch(err => {
                    return reject(err)
                })
            }

            refreshTokenPromise.then(() => {
                if (!Cookie.get('token')) throw "No token"

                console.log("access token received")

                let newConfig = error.response.config
                newConfig.headers['Authorization'] = `Bearer ${Cookie.get('token')}`

                axios.request(newConfig).then((response) => {
                    return resolve(response)
                }).catch(err => {
                    return reject(err)
                })

            }).catch(err => {
                return reject(err)
            })

        } else {
            console.log("interceptor error not token expired")
            return reject(error)
        }
    })
});